import { BASE_URL } from "../../constants/url";
import { makeRequest } from "../../utils/api";
import {
  clearAuthStorage,
  signalForceLogout,
  FORCE_LOGOUT_KEY,
} from "../../utils/sessionUtils";
import md5 from "md5";
import {
  FETCH_GRIEVANCES_REQUEST,
  FETCH_GRIEVANCES_SUCCESS,
  FETCH_GRIEVANCES_FAILURE,
  FETCH_GRIEVANCE_DETAILS_REQUEST,
  FETCH_GRIEVANCE_DETAILS_SUCCESS,
  FETCH_GRIEVANCE_DETAILS_FAILURE,
  FETCH_STATUS_MASTER_REQUEST,
  FETCH_STATUS_MASTER_SUCCESS,
  FETCH_STATUS_MASTER_FAILURE,
  FETCH_APPLICANT_DETAILS,
  FETCH_GRIEVANCE_ESCALATION_MATRIX_FAILURE,
  FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS,
  FETCH_GRIEVANCE_ESCALATION_MATRIX_REQUEST,
  FETCH_GRIEVANCES_BY_SECTION_SUCCESS,
  FETCH_GRIEVANCE_SECTIONS_REQUEST,
  FETCH_GRIEVANCE_SECTIONS_SUCCESS,
  FETCH_GRIEVANCE_SECTIONS_FAILURE,
  LOGIN_SUCCESS,
  FETCH_USERS_SUCCESS,
  FETCH_CENTERS_SUCCESS,
  FETCH_GRANTS_SUCCESS,
  FETCH_GRANTS_REQUEST,
  FETCH_GRANT_DETAILS_SUCCESS,
  FETCH_GRANT_HISTORY_SUCCESS,
  FETCH_GRANT_STATUS_OPTIONS_SUCCESS,
  FETCH_ESCALATION_MATRIX_SUCCESS,
  FETCH_EVENTS_SUCCESS,
  FETCH_POLICIES_REQUEST,
  FETCH_POLICIES_SUCCESS,
  FETCH_POLICIES_FAILURE,
  ADD_POLICY_REQUEST,
  ADD_POLICY_SUCCESS,
  ADD_POLICY_FAILURE,
  UPDATE_POLICY_REQUEST,
  UPDATE_POLICY_SUCCESS,
  UPDATE_POLICY_FAILURE,
  DELETE_POLICY_REQUEST,
  DELETE_POLICY_SUCCESS,
  DELETE_POLICY_FAILURE,
  LOGOUT,
} from "../types";

const API_BASE_URL = BASE_URL;

const safeJsonParse = (text) => {
  try {
    return { data: JSON.parse(text), error: null };
  } catch (error) {
    return { data: null, error };
  }
};

export const login = (credentials) => async (dispatch) => {
  // Rate limiting for POST /api/Register (event 1004) must be enforced on the
  // API/server (HTTP 429). See docs/api-throttling-handoff.md — not fixable in UI.
  try {
    const data = await makeRequest({
      endpoint: "Register",
      eventID: "1004",
      addInfo: {
        email: credentials.username,
        password: md5(credentials.password),
      },
    });

    // console.log("data", data);
    if (data.rCode == 0) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("guid", data.guid);
      localStorage.setItem("roleId", data.rData.ROLE_ID);
      localStorage.setItem("userId", data.rData.USER_ID);
      localStorage.setItem("sectionId", data.rData.UNIT_CENTRE_ID);
      const userData = {
        id: data.rData.USER_ID,
        role: parseInt(data.rData.ROLE_ID),
        token: data.token,
        UNIT_CENTRE_ID: data.rData.UNIT_CENTRE_ID,
        USER_NAME: data.rData.USER_NAME,
        ROLE_NAME: data.rData.ROLE_NAME,
      };
      // console.log(userData)
      localStorage.setItem("user", JSON.stringify(userData));
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          user: userData,
          token: data.token,
        },
      });
      return data;
    } else {
      return data;
    }
  } catch (error) {
    return error;
  }
};

export const fetchGrievanceEscalationMatrix = (id) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Grievance",
      eventID: "1011",
      addInfo: {
        action_at: id,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS,
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS,
        payload: [],
      });
    }
  } catch (error) {
    console.error("Error fetching grievance escalation matrix:", error);
    dispatch({
      type: FETCH_GRIEVANCE_ESCALATION_MATRIX_FAILURE,
      payload: error.message,
    });
  }
};

export const fetchIDCard = () => async (dispatch) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user"));
    const data = await makeRequest({
      endpoint: "Idcard",
      eventID: "1005",
      addInfo: {
        unit_centre_id: userData?.UNIT_CENTRE_ID,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: "FETCH_ID_LIST",
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: "FETCH_ID_LIST",
        payload: [],
      });
    }
  } catch (error) {
    console.error("Error FETCH_ID_LIST", error);
    dispatch({
      type: "FETCH_ID_LIST",
      payload: [],
    });
    return [];
  }
};

export const fetchAttecment = (id, type) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Idcard",
      eventID: "1010",
      addInfo: {
        // idcard_att_id: id,
        type: type,
        id: id,
      },
    });
    console.log(data, "data");
    return data.rData;
  } catch (error) {
    console.error("Error FETCH_ID_LIST", error);
    dispatch({
      type: "FETCH_ID_LIST",
      payload: [],
    });
    return [];
  }
};

export const fetchCardDetails = (id) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Idcard",
      eventID: "1007",
      addInfo: {
        card_id: id,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: "Fetch_Card_Details",
        payload: data.rData[0],
      });
      return data.rData;
    }
  } catch (error) {
    console.error("Error Fetch_Card_Details", error);
    dispatch({
      type: "Fetch_Card_Details",
      payload: [],
    });
    return [];
  }
};
export const updateCardStatus = (payload) => async (dispatch) => {
  const userData = JSON.parse(localStorage.getItem("user"));
  try {
    const data = await makeRequest({
      endpoint: "Idcard",
      eventID: "1006",
      addInfo: {
        card_id: payload.cardId,
        status_id: payload.statusId,
        remarks: payload.remarks,
        user_id: userData.id,
        attachments: [],
      },
    });

    if (data.rCode === 0) {
      return data;
    }
    return data;
  } catch (error) {
    console.error("Error Fetch_Card_Details", error);
    dispatch({
      type: "Fetch_Card_Details",
      payload: [],
    });
    return [];
  }
};
export const fetchCardHistory = (id) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Idcard",
      eventID: "1009",
      addInfo: {
        card_id: id,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: "Fetch_Card_History",
        payload: data,
      });
      return data;
    }
  } catch (error) {
    console.error("Error Fetch_Card_Details", error);
    dispatch({
      type: "Fetch_Card_Details",
      payload: [],
    });
    return [];
  }
};

export const fetchGrievances = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GRIEVANCES_REQUEST });
    const userData = JSON.parse(localStorage.getItem("user"));

    const data = await makeRequest({
      endpoint: "Grievance",
      eventID: "1004",
      addInfo: {
        unit_centre_id: userData?.UNIT_CENTRE_ID,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRIEVANCES_SUCCESS,
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: FETCH_GRIEVANCES_SUCCESS,
        payload: [],
      });
    }
  } catch (error) {
    console.error("Error fetching grievances:", error);
    dispatch({
      type: FETCH_GRIEVANCES_FAILURE,
      payload: error.message,
    });
    return [];
  }
};

export const fetchGrievancesCatMaster = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Grievance",
      eventID: "1001",
      addInfo: {},
    });

    if (data.rCode === 0) {
      dispatch({
        type: "FETCH_GRIEVANCES_CATEGORY_MASTER",
        payload: data.rData,
      });
      return data.rData;
    }
  } catch (error) {
    console.error("Error fetching grievances:", error);
    dispatch({
      type: "FETCH_GRIEVANCES_CATEGORY_MASTER",
      payload: [],
    });
    return [];
  }
};

export const fetchGrievanceDetails = (id) => async (dispatch) => {
  console.log(id);
  try {
    dispatch({ type: FETCH_GRIEVANCE_DETAILS_REQUEST });

    const data = await makeRequest({
      endpoint: "Grievance",
      eventID: "1008",
      addInfo: {
        grv_id: id,
      },
    });

    console.log(data, "data");
    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRIEVANCE_DETAILS_SUCCESS,
        payload: data,
      });
      return data;
    }
  } catch (error) {
    dispatch({
      type: FETCH_GRIEVANCE_DETAILS_FAILURE,
      payload: error.message,
    });

    throw error;
  }
};

export const fetchApplicantDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_APPLICANT_DETAILS });
    const data = await makeRequest({
      endpoint: "User",
      eventID: "1002",
      addInfo: {
        esm_id: id,
      },
    });

    console.log(data, "data");
    if (data.rCode === 0) {
      dispatch({
        type: FETCH_APPLICANT_DETAILS,
        payload: data.rData[0],
      });
      return data;
    }
  } catch (error) {
    console.error("Error fetching status master:", error);
    dispatch({
      type: FETCH_STATUS_MASTER_FAILURE,
      payload: error.message,
    });

    return [];
  }
};

export const forwardGrievanceToBranch = (id, comments) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Grievance",
      eventID: "1009",
      addInfo: {
        is_forwarded: "1",
        grv_id: id,
      },
    });

    if (data.rCode === 0) {
      return data;
    }
  } catch (error) {
    console.error("Forward Grievance Error:", error);
    throw error;
  }
};

export const updateGrievanceStatus =
  (id, statusId, remarks, attachments = [], fromCatId, toCatId) =>
  async (dispatch) => {
    try {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      const userId = user.id || "";

      const data = await makeRequest({
        endpoint: "Grievance",
        eventID: "1007",
        addInfo: {
          grv_id: id,
          remarks: remarks,
          status: statusId,
          u_id: userId,
          from_grv_cat_id: statusId == "2" ? fromCatId : "",
          to_grv_cat_id: toCatId || "",
          attachments: attachments || [],
        },
      });
      console.log(data);
      return data;
    } catch (error) {
      console.error("Update Grievance Status Error:", error);

      return error;
    }
  };

export const fetchStatusMaster = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_STATUS_MASTER_REQUEST });

    // Make API call to fetch status master list
    const response = await fetch(`${API_BASE_URL}/Grievance`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        eventID: "1006",
        addInfo: {},
      }),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status} ${response.statusText}`);
    }

    const responseText = await response.text();

    if (!responseText || responseText.trim() === "") {
      throw new Error("Empty response received from server");
    }

    const { data: responseData, error: parseError } =
      safeJsonParse(responseText);

    if (parseError) {
      throw new Error(
        `Invalid JSON response: ${responseText.substring(0, 100)}...`
      );
    }

    // console.log("Status master response:", responseData);

    if (responseData.rStatus !== 0) {
      throw new Error(
        responseData.rData?.rMessage || "Failed to fetch status master"
      );
    }

    // Get the status list from the API response
    const statusList = responseData.rData?.status || [];

    // Cache the status master list for use by status utils
    localStorage.setItem("statusMasterList", JSON.stringify(statusList));

    dispatch({
      type: FETCH_STATUS_MASTER_SUCCESS,
      payload: statusList,
    });

    return statusList;
  } catch (error) {
    console.error("Error fetching status master:", error);
    dispatch({
      type: FETCH_STATUS_MASTER_FAILURE,
      payload: error.message,
    });

    // No fallback, just return empty array
    return [];
  }
};

// get GetMasterSection
export const fetchGrievanceSections = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GRIEVANCE_SECTIONS_REQUEST });

    const data = await makeRequest({
      endpoint: "Grievance",
      eventID: "1016",
      addInfo: {},
    });

    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRIEVANCE_SECTIONS_SUCCESS,
        payload: data.rData,
      });
      return data.rData;
    }

    console.log(data, "sectionuserGrievanceData");
  } catch (error) {
    console.error("Error fetching grievance sections:", error);
    dispatch({
      type: FETCH_GRIEVANCE_SECTIONS_FAILURE,
      payload: error.message,
    });
    return [];
  }
};

// get GetGrievanceBySectionId
export const fetchGrievancesBySection = (sectionId) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Grievance",
      eventID: "1015",
      addInfo: {
        section_id: sectionId,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRIEVANCES_BY_SECTION_SUCCESS,
        payload: data.rData,
      });
      return data.rData;
    }
  } catch (error) {
    console.error("Error fetching grievances by section:", error);
    return [];
  }
};

export const fetchAresaCenter = () => async (dispatch) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user"));
    const response = await fetch(`${API_BASE_URL}/AresaCentres`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        eventID: "1001",
        addInfo: {},
      }),
    });

    const responseText = await response.json();

    const areseCenter = responseText.rData?.rData || [];
    console.log(areseCenter);
    return areseCenter;
  } catch (error) {
    console.error("Error fetching grievances:", error);
    dispatch({
      type: FETCH_GRIEVANCES_FAILURE,
      payload: error.message,
    });
    return [];
  }
};

export const fetchUsers = (centerId) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "User",
      eventID: "1009",
      addInfo: {
        center_id: centerId,
      },
    });

    if (data.rCode == 0) {
      dispatch({
        type: FETCH_USERS_SUCCESS,
        payload: data.rData,
      });
    }

    return data.rData;
  } catch (error) {
    console.error("Error fetching users:", error);

    return [];
  }
};

export const fetchAllUsers = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "User",
      eventID: "1014",
      addInfo: {},
    });
    if (data.rCode === 0) {
      dispatch({
        type: FETCH_USERS_SUCCESS,
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: FETCH_USERS_SUCCESS,
        payload: [],
      });
    }
  } catch (error) {
    return [];
  }
};

export const toggleUserStatus =
  (userId, status, remarks) => async (dispatch) => {
    try {
      const data = await makeRequest({
        endpoint: "Status",
        eventID: "1002",
        addInfo: {
          user_id: userId,
          status: status,
          remarks: remarks,
        },
      });
      return data;
    } catch (error) {
      throw error;
    }
  };

export const fetchUserAttachments = (userId) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "User",
      eventID: "1010",
      addInfo: {
        user_id: userId,
      },
    });
    return data.rData;
  } catch (error) {
    return [];
  }
};
export const fetchCentersDetails = (id) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "AresaCentres",
      eventID: "1003",
      addInfo: {
        unit_center_id: id,
      },
    });
    console.log(data, "data");
    if (data.rCode == 0) {
      const res = data.rData;
      return res;
    }
  } catch (error) {
    return [];
  }
};

export const fetchCenters = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "AresaCentres",
      eventID: "1001",
      addInfo: {},
    });

    if (data.rCode == 0) {
      const transformedCenters = data.rData.map((center) => ({
        id: center.UNIT_CENTRE_ID,
        name: `${center.UNIT_CENTRE_ID}`,
        location: center.ADDRESS,
        presidentRank: center.PRE_RANK_ID || "N/A",
        presidentName: center.PRE_NAME || "N/A",
        presidentMobile1: center.PRE_MOBILE_NO || "N/A",
        presidentMobile2: center.PRESIDENT_MOB2 || "N/A",
        secretaryRank: center.SEC_RANK_ID || "N/A",
        secretaryName: center.SEC_NAME || "N/A",
        secretaryMobile1: center.SEC_MOBILE_NO || "N/A",
        secretaryMobile2: center.SECRETARY_MOB2 || "N/A",
        remarks: center.REMARK || "N/A",
        SEC_WEF_DATE:center.SEC_WEF_DATE.split(" ")[0],
        PRE_WEF_DATE:center.PRE_WEF_DATE.split(' ')[0],
        PRE_LAST_UNIT_SERVED:center.PRE_LAST_UNIT_SERVED,
        PRE_TRADE_NAME:center.PRE_TRADE_NAME,
        SEC_LAST_UNIT_SERVED:center.SEC_LAST_UNIT_SERVED,
        SEC_TRADE_NAME:center.SEC_TRADE_NAME,
        isActive: true,
        totalUsers: 0,
        totalGrievances: 0,
      }));

      dispatch({
        type: FETCH_CENTERS_SUCCESS,
        payload: transformedCenters,
      });

      return transformedCenters;
    }
  } catch (error) {
    return [];
  }
};

export const fetchGrants = () => async (dispatch) => {
  try {
    const userData = JSON.parse(localStorage.getItem("user"));

    const data = await makeRequest({
      endpoint: "Grants",
      eventID: "1005",
      addInfo: {
        unit_centre_id: "0",
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRANTS_SUCCESS,
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: FETCH_GRANTS_SUCCESS,
        payload: [],
      });
    }
  } catch (error) {
    console.error("Error fetching grants:", error);
  }
};

export const fetchGrantsBySection = (sectionId) => async (dispatch) => {
  try {
    dispatch({ type: "FETCH_GRANTS_BY_SECTION_REQUEST" });

    const data = await makeRequest({
      endpoint: "grants",
      eventID: "1011",
      addInfo: {
        section_id: sectionId,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: "FETCH_GRANTS_BY_SECTION_SUCCESS",
        payload: data.rData,
      });
      return data.rData;
    }
  } catch (error) {
    console.error("Error fetching grants by section:", error);
  }
};

export const fetchGrantEscalationMatrix = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_GRIEVANCE_ESCALATION_MATRIX_REQUEST });

    const data = await makeRequest({
      endpoint: "Grants",
      eventID: "1009",
      addInfo: {
        action_at: id,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS,
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: FETCH_GRIEVANCE_ESCALATION_MATRIX_SUCCESS,
        payload: [],
      });
    }
  } catch (error) {
    console.error("Error fetching grievance escalation matrix:", error);
  }
};

export const fetchGrantById = (app_id) => async (dispatch, getState) => {
  try {
    dispatch({ type: FETCH_GRANTS_REQUEST });
    const data = await makeRequest({
      endpoint: "Grants",
      eventID: "1007",
      addInfo: {
        app_id: app_id,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRANT_DETAILS_SUCCESS,
        payload: data,
      });
      dispatch({
        type: FETCH_GRANT_HISTORY_SUCCESS,
        payload: data,
      });
      return data.rData;
    }
  } catch (error) {}
};

export const updateGrantStatus =
  (appId, statusId, remarks, userId, files = []) =>
  async (dispatch) => {
    try {
      const processedAttachments = await processFilesForUpload(files);

      const data = await makeRequest({
        endpoint: "Grants",
        eventID: "1006",
        addInfo: {
          app_id: appId,
          remarks: remarks,
          status_id: statusId,
          user_id: userId,
          attachments: processedAttachments,
        },
      });

      if (data.rCode === 0) {
        dispatch({
          type: "Grant_Application_Details",
          payload: data,
        });
        return data;
      }
      return data;
    } catch (error) {
      console.error(`Error updating grant status for ID ${appId}:`, error);
      throw error;
    }
  };

export const fetchGrantStatusOptions = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Grants",
      eventID: "1008",
      addInfo: {},
    });
    if (data.rCode === 0) {
      dispatch({
        type: FETCH_GRANT_STATUS_OPTIONS_SUCCESS,
        payload: data.rData,
      });

      return data;
    }
  } catch (error) {
    console.error("Error fetching grant status options:", error);
  }
};

export const fetchEscalationMatrix = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Grievance",
      eventID: "1012",
      addInfo: {},
    });
    if (data.rCode === 0) {
      dispatch({
        type: FETCH_ESCALATION_MATRIX_SUCCESS,
        payload: data.rData,
      });

      return data;
    }
  } catch (error) {
    // Return empty array to prevent further errors
    return [];
  }
};

export const fetchEvents = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Event",
      eventID: "1002",
      addInfo: {},
    });
    if (data.rCode == 0) {
      dispatch({
        type: FETCH_EVENTS_SUCCESS,
        payload: data?.rData,
      });
    }
  } catch (error) {
    console.error("Update Grievance Status Error:", error);
    throw error;
  }
};

export const fetchPolicies = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_POLICIES_REQUEST });
    
    const data = await makeRequest({
      endpoint: "policy",
      eventID: "1002",
      addInfo: {},
    });
    
    if (data.rCode == 0) {
      dispatch({
        type: FETCH_POLICIES_SUCCESS,
        payload: data?.rData || [],
      });
    } else {
      dispatch({
        type: FETCH_POLICIES_FAILURE,
        payload: data?.rMessage || "Failed to fetch policies",
      });
    }
  } catch (error) {
    console.error("Fetch Policies Error:", error);
    dispatch({
      type: FETCH_POLICIES_FAILURE,
      payload: "Failed to fetch policies",
    });
    throw error;
  }
};

export const fetchPolicyDocument = (policyId) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "policy",
      eventID: "1003",
      addInfo: {
        policy_id: policyId
      },
    });
    
    if (data.rCode == 0) {
      // Handle both possible shapes:
      // 1) { rData: { rData: [{ ATTACHMENT }] } }
      // 2) { rData: [{ ATTACHMENT }] }
      const inner = Array.isArray(data?.rData?.rData)
        ? data.rData.rData
        : data?.rData;
      if (Array.isArray(inner)) {
        return inner[0]?.ATTACHMENT || null;
      }
      // or object
      return inner?.ATTACHMENT || null;
    } else {
      throw new Error(data?.rMessage || "Failed to fetch policy document");
    }
  } catch (error) {
    console.error("Fetch Policy Document Error:", error);
    throw error;
  }
};

export const addPolicy = (policyData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_POLICY_REQUEST });
    const data = await makeRequest({
      endpoint: "policy",
      eventID: "1001",
      addInfo: policyData,
    });

    if (data.rCode === 0) {
      dispatch({
        type: ADD_POLICY_SUCCESS,
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: ADD_POLICY_FAILURE,
        payload: data.rMessage || "Failed to add policy",
      });
      throw new Error(data.rMessage || "Failed to add policy");
    }
  } catch (error) {
    dispatch({
      type: ADD_POLICY_FAILURE,
      payload: error.message,
    });
    throw error;
  }
};

export const updatePolicy = (policyId, policyData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_POLICY_REQUEST });
    const data = await makeRequest({
      endpoint: "policy",
      eventID: "1004",
      addInfo: {
        policy_id: policyId,
        ...policyData,
      },
    });

    if (data.rCode === 0 || data?.rData?.rCode === 0) {
      dispatch({
        type: UPDATE_POLICY_SUCCESS,
        payload: { id: policyId, ...policyData },
      });
      return data?.rData || data;
    } else {
      const message = data?.rMessage || data?.rData?.rMessage || "Failed to update policy";
      dispatch({ type: UPDATE_POLICY_FAILURE, payload: message });
      throw new Error(message);
    }
  } catch (error) {
    dispatch({ type: UPDATE_POLICY_FAILURE, payload: error.message });
    throw error;
  }
};

// Delete policy (eventID: 1005)
export const handleDeletePolicy = (policyId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_POLICY_REQUEST });
    const data = await makeRequest({
      endpoint: "policy",
      eventID: "1005",
      addInfo: { policy_id: String(policyId) },
    });

    const isOk = data?.rData?.rCode === 0 || data?.rCode === 0;
    const message = data?.rData?.rMessage || data?.rMessage || (isOk ? "Policy deleted successfully." : "Failed to delete policy");

    if (isOk) {
      dispatch({ type: DELETE_POLICY_SUCCESS, payload: String(policyId) });
      return { rCode: 0, rMessage: message };
    } else {
      dispatch({ type: DELETE_POLICY_FAILURE, payload: message });
      return { rCode: 1, rMessage: message };
    }
  } catch (error) {
    dispatch({ type: DELETE_POLICY_FAILURE, payload: error.message });
    return { rCode: 1, rMessage: error.message };
  }
};

const processFilesForUpload = async (files) => {
  if (!files || files.length === 0) return [];

  try {
    // Map each file object to the required format
    const processedFiles = files.map((file) => {
      return {
        att_id:
          file.att_id || String(Date.now() + Math.floor(Math.random() * 1000)),
        att_name: file.name || "",
        att_details: file.desc || `File: ${file.name || ""}`,
        attachment: file.src || "",
        att_type: file.name ? file.name.split(".").pop() : "",
        doc_no: file.doc_no || `DOC${Date.now().toString().slice(-6)}`,
      };
    });

    return processedFiles;
  } catch (error) {
    console.error("Error processing files:", error);
    throw new Error("Failed to process files");
  }
};

export const fetchtApplicationDetails = (esm) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Grants",
      eventID: "1004",
      addInfo: {
        esm_id: esm,
      },
    });

    if (data.rCode === 0) {
      dispatch({
        type: "Grant_Application_Details",
        payload: data.rData,
      });

      return data;
    }
  } catch (error) {}
};

export const logout = (options = {}) => async (dispatch) => {
  const { broadcast = false } = options || {};

  // Call logout API while token/guid are still available; clear local session either way.
  try {
    await makeRequest({
      endpoint: "logout",
      eventID: "1001",
      addInfo: {},
    });
  } catch (error) {
    // Still proceed with local logout if API fails
  }

  if (broadcast) {
    signalForceLogout();
  }
  clearAuthStorage();
  localStorage.removeItem(FORCE_LOGOUT_KEY);
  dispatch({ type: LOGOUT });
};

export const forwardGrievanceToDGAR =
  (id, comments, attachments = []) =>
  async (dispatch) => {
    return forwardGrievanceToBranch(id, comments, attachments)(dispatch);
  };

// dashboard code
export const fetchDashboardCount = (id, type) => async (dispatch) => {
  try {
    const roleID = Number(localStorage.getItem("roleId"));
    const data = await makeRequest({
      endpoint: "Dashboard",
      eventID: "1001",
      addInfo: {
        type: type,
        unit_centre_id: type == "user" ? 1 : id,
      },
    });
    if (data.rCode === 0) {
      if (type == "user") {
        dispatch({
          type: "User_Dashboard_Data",
          payload: data.rData,
        });
      } else if (type == "idcard") {
        dispatch({
          type: "IdCard_Dashboard_Data",
          payload: data.rData,
        });
      } else if (type == "grants") {
        dispatch({
          type: "Grants_Dashboard_Data",
          payload: data.rData,
        });
      } else if (type == "grievance") {
        dispatch({
          type: "Grievance_Dashboard_Data",
          payload: data.rData,
        });
      } else if (type == "grantsescalarated") {
        dispatch({
          type: "Grantsescalarated_Dashboard_Data",
          payload: data.rData,
        });
      } else if (type == "grievancesescalarated") {
        dispatch({
          type: "Grievancesescalarated_Dashboard_Data",
          payload: data.rData,
        });
      } else if (type == "events") {
        dispatch({
          type: "Events_Dashboard_Data",
          payload: data.rData,
        });
      }

      return data.rData;
    }
  } catch (error) {
    console.error("Error FETCH_ID_LIST", error);

    return [];
  }
};

export const handleAddEvent = (eventData) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Event",
      eventID: "1001",
      addInfo: eventData.addInfo,
    });
    console.log(data);
    return data;
  } catch (error) {}
};
export const handleDeleteEvent = (id) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Event",
      eventID: "1004",
      addInfo: {
        event_id: id,
      },
    });
    console.log(data);
    return data;
  } catch (error) {}
};

export const handleUpdateEvents = (eventData) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Event",
      eventID: "1003",
      addInfo: eventData.addInfo,
    });
    console.log(data);
    return data;
  } catch (error) {}
};

export const locationMasters = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "master",
      eventID: "1003",
      addInfo: {},
    });
    console.log(data);
    if (data.rCode == 0) {
      dispatch({
        type: "Location_Master",
        payload: data.rData,
      });
    } else {
      dispatch({
        type: "Location_Master",
        payload: [],
      });
    }
    return data;
  } catch (error) {}
};
export const getAllUserRole = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "master",
      eventID: "1004",
      addInfo: {},
    });
    console.log(data);
    if (data.rCode == 0) {
      dispatch({
        type: "UserRole_Master",
        payload: data.rData,
      });
    } else {
      dispatch({
        type: "UserRole_Master",
        payload: [],
      });
    }
    return data;
  } catch (error) {}
};

export const handleChangePassword = (eventData) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "Register",
      eventID: "1005",
      addInfo: eventData.addInfo,
    });
    console.log(data);

    return data;
  } catch (error) {}
};
export const getAllUserList = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "User",
      eventID: "1016",
      addInfo: {},
    });
    if (data.rCode === 0) {
      dispatch({
        type: "Get_All_User_List",
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: "Get_All_User_List",
        payload: [],
      });
    }
  } catch (error) {
    return [];
  }
};

export const getAllAresaCeter = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "AresaCentres",
      eventID: "1001",
      addInfo: {},
    });
    if (data.rCode === 0) {
      dispatch({
        type: "Get_All_Center_List",
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: "Get_All_Center_List",
        payload: [],
      });
    }
  } catch (error) {
    return [];
  }
};
export const getAllRankLists = () => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "master",
      eventID: "1002",
      addInfo: {},
    });
    if (data.rCode === 0) {
      dispatch({
        type: "Get_All_Rank_List",
        payload: data.rData,
      });
      return data.rData;
    } else {
      dispatch({
        type: "Get_All_Rank_List",
        payload: [],
      });
    }
  } catch (error) {
    return [];
  }
};
export const handleAddMember = (memberData) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "User",
      eventID: "1015",
      addInfo: memberData.addInfo,
    });
    return data;
  } catch (error) {
    return [];
  }
};

export const resetPassword = (password) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "user",
      eventID: "1018",
      addInfo: password,
    });
    console.log(data);
    return data;
  } catch (error) {}
};

export const handleDeleteUser = (role, id) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "user",
      eventID: "1017",
      addInfo: {
        role_id: role,
        user_id: id,
      },
    });
    console.log(data);
    return data;
  } catch (error) {}
};


export const handleUpdateCenter = (eventData) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "AresaCentres",
      eventID: "1004",
      addInfo: eventData.addInfo,
    });
    console.log(data);
    return data;
  } catch (error) {}
};
export const handleUpdateMember = (memberData) => async (dispatch) => {
  try {
    const data = await makeRequest({
      endpoint: "User",
      eventID: "1019",
      addInfo: memberData.addInfo,
    });
    return data;
  } catch (error) {
    return [];
  }
}
